import React from 'react';
import { Box, Text, useColorModeValue } from '@chakra-ui/react';
import { BracketMatchDisplay, MundialTeam } from '../../types/mundial';
import { WorldCupBracketView } from './WorldCupBracketView';

interface KnockoutBracketProps {
  teams: MundialTeam[];
  matchesByRound: Record<string, BracketMatchDisplay[]>;
}

export const KnockoutBracket: React.FC<KnockoutBracketProps> = ({
  teams,
  matchesByRound,
}) => {
  const hintColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box w="100%" maxW="100%">
      <Text fontSize="sm" color={hintColor} mb={4}>
        La llave se completa automáticamente conforme avanzan
        los equipos clasificados.
      </Text>
      <WorldCupBracketView teams={teams} matchesByRound={matchesByRound} />
    </Box>
  );
};
